import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import './onLoadPopup.css';

function OnLoadPopup() {
  const [spinner, setSpinner] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    phone_number: '',
    service_required: '',
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      openSweetForm();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event, payloadData) => {
    event.preventDefault();
    setSpinner(true);
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payloadData),
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/purity/v1/leads/contactus/submit`, requestOptions);
      setSpinner(false);

      if (response.ok) {
        swal({
          title: "Query Submitted",
          text: "Team will get back to you shortly",
          icon: "success"
        });
      } else {
        swal({
          title: "Failed!",
          text: "Please check your details and try again",
          icon: "error"
        });
      }
    } catch (error) {
      setSpinner(false);
      console.error('Error submitting form data:', error);
      swal({
        title: "Network Error",
        text: "Please try again later",
        icon: "error"
      });
    }
  };

  const openSweetForm = () => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = `
    <form id="sweetForm" class="form-container">
      <div class="form-input">
        <label for="full_name">Your Name</label>
        <input type="text" id="full_name" name="full_name" required />
      </div>
      <div class="form-input">
        <label for="phone_number">Phone Number</label>
        <input type="number" id="phone_number" name="phone_number" required />
      </div>
      <div class="form-input">
        <label for="service_required">Select Services</label>
        <select id="service_required" name="service_required" required>
          <option value="">Choose here</option>
          <option value="Sell gold">Sell Gold</option>
          <option value="Release Pledged Gold">Release Pledged Gold</option>
          <option value="RePledge Your Gold">Re-Pledge Your Gold</option>
          <option value="24 Rent Gold">Rent Gold</option>
        </select>
      </div>
      <div class="form-submit">
        <button type="submit" class="swal-button">Submit</button>
      </div>
    </form>
  `;

    swal({
      title: "Enquire Now",
      content: wrapper,
      buttons: false,
      closeOnClickOutside: false,
    });

    setTimeout(() => {
      const formElement = document.getElementById("sweetForm");
      formElement.addEventListener("submit", async (e) => {
        e.preventDefault();
        const payload = {
          full_name: formElement.full_name.value,
          phone_number: formElement.phone_number.value,
          service_required: formElement.service_required.value,
        };
        await handleSubmit(e, payload);
      });
    }, 100);
  };


  return null;
}

export default OnLoadPopup;
